import { useEffect, useState } from "react";
import CustomTable from "../../widgets/table/index";
import HeaderSection from "../common/headerSection";
import PageHeader from "../common/pageHeader";
import { userService } from "../../service/plateServices";
import Pagination from "../../widgets/pagination";
import { EsignModal } from "../../widgets/alertModal";

import { dashboardServices } from "../../service/dashboard";

import { scheduleService } from "../../service/scheduleService";
import { DEFAULT_PAGE_SIZE } from "../../constants/constants";
import { useTranslation } from "react-i18next";
import CustomToast from "../../widgets/toaster";
import { columnsHistory, columnsNew } from "././partials/columns";
import PlateDetailsViewModel from "../lab_operator/labReport/models/plateDetailsModel";
import moment from "moment";
import ProductionBatchSummaryReport from "../admin/reportpdf/summaryReport/productionbatchSummaryReport";
import { Button, Modal } from "react-bootstrap";
import { TfiClose } from "react-icons/tfi";

type LabtestStatType = {
  pending_plates_for_lab_approval: number;
  lab_approved_plates: number;
  escalations: number;
};

interface EsignParams {
  selectedIds: string;
  status: string;
  productionScheduleNames: string;
}

const QAReviewAndApproval = () => {

  const { t } = useTranslation();
  
  const currentDate = new Date().toISOString().split('T')[0];
  const [tab, setTab] = useState("1");
  const [showView, setShowView] = useState(false);
  const [plateDetails, setPlateDetails] = useState<Array<any>>([]);
  const [plateDetailsHistory, setPlateDetailsHistory] = useState<Array<any>>([]);
  const [useEffectRequired, setUseEffectRequired] = useState(false);
  const [plateBatches, setPlateBatches] = useState([]);
  const [plateSerielNum, setPlateSerielNums] = useState([]);
  const [keyWord, setkeyWord] = useState("");
  const [historyKeyWord, setHistoryKeyWord] = useState("");
  const [userId, setUserId] = useState<number>(0);
  const [showEsignAlert, setShowEsignAlert] = useState(false)
  const [labtestStat, setLabTestStat] = useState<LabtestStatType | null>(null);
  const [selectedTab, setSelectedTab] = useState<number | null>(null);
  const [plateId, setPlateId] = useState("");
  const [activityType, setActivityType] = useState<Array<any>>([]);
  const [areaList, setAreaList] = useState<Array<any>>([]);
  const [activityTypeId, setActivityTypeId] = useState("");
  const [areaId, setAreaId] = useState("");
  const [batchCode, setBatchCode] = useState("");
  const [fromDate, setFromDate] = useState(
    new Date(new Date().setDate(new Date().getDate() - 7))
      .toISOString()
      .split("T")[0]
  );
  const [toDate, setToDate] = useState(currentDate);
  const [activityTypeIdHistory, setActivityTypeIdHistory] = useState("");
  const [areaIdHistory, setAreaIdHistory] = useState("");
  const [batchCodeHistory, setBatchCodeHistory] = useState("");
  const [fromDateHistory, setFromDateHistory] = useState(
    new Date(new Date().setDate(new Date().getDate() - 7))
      .toISOString()
      .split("T")[0]
  );
  const [toDateHistory, setToDateHistory] = useState(currentDate);



  // pagination
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [totalPages, setTotalPages] = useState(0);
  const [totalElements, setTotalElements] = useState(0);

  //history pagination
  const [historyPage, setHistoryPage] = useState(1);
  const [historyPageSize, setHistoryPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [historyTotalPages, setHistoryTotalPages] = useState(0);
  const [historyTotalElements, setHistoryTotalElements] = useState(0);
  const [esignParams, setEsignParams] = useState<EsignParams | null>(null);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const [prodScheduleList, setProdScheduleList] = useState<Array<any>>([]);
  const [productList, setProductList] = useState<Array<any>>([]);
  const [scheduleProductId, setScheduleProductId] = useState("");
  const [productId, setProductId] = useState("");
  const [historyScheduleProductId, setHistoryScheduleProductId] = useState("");
  const [historyProductId, setHistoryProductId] = useState("");
  const [sort, setSort] = useState("id");
  const [order, setOrder] = useState("desc");
  const [sortHistory, setSortHistory] = useState("id");
  const [orderHistory, setOrderHistory] = useState("desc");
  const [productionType, setProductionType] = useState("");

  const sortRemoveList=["StartAndEnd","status","production_schedule","product_name"]
  const sortRemoveListHistory=["StartAndEnd","status","production_schedule","product_name"]

  // Render initial api calls 
 useEffect(() => {
  var storedData = localStorage.getItem('userDetails');

  if(storedData) {
    var storedObject = JSON.parse(storedData);
    setUserId(storedObject[0].id)
  }
  getLabtestStatuDetails();
  getProductionScheduleList();
  getProductionScheduleHistoryList(storedObject[0].id);
  listPlateBatch();
  listSerialNumber();
  getActivityTypeList();
  getAreaList();
  getProductionSchedules();
  getProductList();

  setUseEffectRequired(false)
}, [useEffectRequired]);
  //get lab report stat details on top 
  const getLabtestStatuDetails = async () => {
    try {
      const response = await dashboardServices.getLabtestStatuDetails(); 
        if(response.status && response.statusCode === 200){
          setLabTestStat({
  
            pending_plates_for_lab_approval: response.data.pending_plates_for_lab_approval,
            lab_approved_plates : response.data.reviewed_plates_count,
            escalations : response.data.escalations,
            });
      }
    } catch (error) {
      console.error(error);
    }
    };
  
  // on click request table 
  const handleViewClick = (id: string, viewValue: boolean) => {
    const updatedData = plateDetails.filter((row) => row.slno === id);
    setPlateId(updatedData[0]?.id)
    setShowView(viewValue);
  };

  // on click history table 
  const handleHistoryView = (id: string, viewValue: boolean) => {
    const updatedData = plateDetailsHistory?.filter((row) => row.slno === id);
    setPlateId(updatedData[0]?.id)
    setShowView(viewValue);
  };

  // get Activity Type List
    const getActivityTypeList = async () => {
      try {
      const response = await scheduleService.getActivityTypeList();
      if (response.status && response.statusCode === 200) {
          try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
              let rowData: any = response.data.map(
              (element: any, index: number) => {
                  return {
                  slno: index + 1,
                  id: element.id,
                  name: element.name,
                  };
              }
              );
              setActivityType(rowData);
          }
          } catch (error) {
          console.log(error);
          }
      } else {
          setActivityType([]);
      }
      } catch (error) {
      console.error("user response", error);
      }
    };

  //api call to get area list
  const getAreaList = async () => {
    try {
      const response = await scheduleService.getAreaList("id", "desc", "6,17");
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  id: element.id,
                  name: element.name,
                  grade_name: element.grade_name,
                };
              }
            );
            setAreaList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setAreaList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  // get ProductionScheduleList
  const getProductionSchedules = async () => {
    try {
      const response = await scheduleService.getProductionSchedules();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  slno: index + 1,
                  id: element.id,
                  production_schedule_name: element?.production_schedule_name,
                  activity_type_id: element.activity_type_id,
                };
              }
            );
            setProdScheduleList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setProdScheduleList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

  const capitalizeFirstLetter = (str: string) => {
  if (!str) return str;
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

  //api call to get area list
  const getProductList = async () => {
    try {
      const response = await scheduleService.getProductList();
      if (response.status && response.statusCode === 200) {
        try {
          if (Array.isArray(response.data) && response.data?.length > 0) {
            let rowData: any = response.data.map(
              (element: any, index: number) => {
                return {
                  id: element.id,
                  name: element.name,
                };
              }
            );
            setProductList(rowData);
          }
        } catch (error) {
          console.log(error);
        }
      } else {
        setProductList([]);
      }
    } catch (error) {
      console.error("user response", error);
    }
  };

 



const getProductionScheduleList = async () => {
  try {
    const response = await scheduleService.getQAProductionSchedules(
      page,
      pageSize,
      sort,
      order,
      scheduleProductId,  
      "pending",          
      fromDate,           
      toDate,             
      productId           
    );
    
    if (response.status && response.statusCode === 200) {
      const formattedData = response.data.map((item: any, index: number) => ({
        slno: index + 1,
        id: item.id,
        production_schedule: item.production_schedule_name,
        product_name: item.product_name || item.schedule_product_name,
        area_name: item.area_name,
        StartAndEnd: `
          ${item.from_date_time ? moment(item.from_date_time).format("DD-MM-YYYY") : '-'} 
          to 
          ${item.to_date_time ? moment(item.to_date_time).format("DD-MM-YYYY") : '-'}
        `,
        status: capitalizeFirstLetter(item.approval_status),
      }));
      
      setPlateDetails(formattedData);
      setTotalPages(response.totalPages);
      setTotalElements(response.totalElements);
    } else {
      setPlateDetails([]);
      setTotalPages(0);
      setTotalElements(0);
    }
  } catch (error) {
    console.error("Error fetching production schedule:", error);
    setPlateDetails([]);
  }
};

const getProductionScheduleHistoryList = async (authUserId:number) => {
  try {
    const response = await scheduleService.getQAProductionSchedules(
      historyPage,
      historyPageSize,
      sortHistory,
      orderHistory,
      historyScheduleProductId,  // schedule_production_id
      "approved,rejected", // approval_status for history tab
      fromDateHistory,    // fromDate
      toDateHistory,      // toDate
      historyProductId,          // product_id
      authUserId
    );
    
    if (response.status && response.statusCode === 200) {
      const formattedData = response.data.map((item: any, index: number) => ({
        slno: index + 1,
        id: item.id,
        production_schedule: item.production_schedule_name,
        product_name: item.product_name || item.schedule_product_name,
        area_name: item.area_name,
        StartAndEnd: `
          ${item.from_date_time ? moment(item.from_date_time).format("DD-MM-YYYY") : '-'} 
          to 
          ${item.to_date_time ? moment(item.to_date_time).format("DD-MM-YYYY") : '-'}
        `,
        status: capitalizeFirstLetter(item.approval_status),
      }));
      
      setPlateDetailsHistory(formattedData);
      setHistoryTotalPages(response.totalPages);
      setHistoryTotalElements(response.totalElements);
    } else {
      setPlateDetailsHistory([]);
      setHistoryTotalPages(0);
      setHistoryTotalElements(0);
    }
  } catch (error) {
    console.error("Error fetching history:", error);
    setPlateDetailsHistory([]);
  }
};


  //request table pagination 
  const handlePageChange = (newPage : any, pageSize?: number) => {
    setPage(newPage);
    if(pageSize) {
      setPageSize(pageSize)
    }
    setUseEffectRequired(true)
  };

  //history table pagination 
  const handleHistoryPageChange = (newPage : any, pageSize?: number) => {
    setHistoryPage(newPage);
    if(pageSize) {
      setHistoryPageSize(pageSize)
    }
    setUseEffectRequired(true)
  };

  //history table filter options 
  const handleFilter = (key: string, value: any) => {
    if (key === "search") {
      setkeyWord(value)
    }  else if (key === "FromDate") {
      setFromDate(value)
      setToDate("")
    } else if (key === "ToDate") {
      setToDate(value)
    }   else if (key === "productionSchedule") {
      setScheduleProductId(value)
    } else if (key === "productName") {
      setProductId(value)
    }

    setUseEffectRequired(true)
  }

  //handle history table filter options 
  const handleHistoryFilter = (key: string, value: any) => {
    if (key === "search") {
      setHistoryKeyWord(value)
    }  else if (key === "FromDate") {
      setFromDateHistory(value)
      setToDateHistory("")
    } else if (key === "ToDate") {
      setToDateHistory(value)
    } else if (key === "productionSchedule") {
      setHistoryScheduleProductId(value)
    } else if (key === "productName") {
      setHistoryProductId(value)
    }
    setUseEffectRequired(true)
  }

  //list plate batch api for filter
  const listPlateBatch = async () => {
    try {
      const response = await userService.listPlateBatch();
      if(response.status && response.statusCode === 200){
        try {
            if ( Array.isArray(response.data) && response.data?.length > 0) {
              let rowData: any = response.data.map((element: any, index: number) => {
  
                return { 
                    value: element.batch_number,
                    label: element.batch_number ,
                };
              });
              setPlateBatches(rowData);
            }
          } catch (error) {
            console.log(error); 
          }
      }
    } catch (error) {
      console.error('Plate response', error);
    }
  }

  //list serial number api for filter 
  const listSerialNumber = async () => {
    try {
      const response = await userService.listSerialNumber();
      if(response.status && response.statusCode === 200){
        try {
            if ( Array.isArray(response.data) && response.data?.length > 0) {
              let rowData: any = response.data.map((element: any, index: number) => {
  
                return { 
                    value: element.serial_number,
                    label: element.serial_number ,
                };
              });
              setPlateSerielNums(rowData);
            }
          } catch (error) {
            console.log(error); 
          }
      }
    } catch (error) {
      console.error('Plate response', error);
    }
  }

  //on click on approve button in request 
  const handleApproveBtn = (selectedRows: any[]) => {
    const filteredPlateDetails = plateDetails.filter((item) => selectedRows.includes(item.slno));
    const selectedIds = filteredPlateDetails
        .filter((item) => item.id.trim() !== '')
        .map((item) => item.id)
        .join(',');
    const productionScheduleNames = filteredPlateDetails
        .filter((item) => item.production_schedule)
        .map((item) => item.production_schedule)
        .join(',');
    setShowEsignAlert(true);
    const status = "approved";
    setEsignParams({ selectedIds, status,productionScheduleNames });
};

  //on click on reject button in history 
  const handleRejectBtn = (selectedRows: any[]) => {
    const filteredPlateDetails = plateDetails.filter((item) => selectedRows.includes(item.slno));
    const selectedIds = filteredPlateDetails
        .filter((item) => item.id.trim() !== '')
        .map((item) => item.id)
        .join(',');
    const productionScheduleNames = filteredPlateDetails
        .filter((item) => item.production_schedule_name)
        .map((item) => item.production_schedule_name)
        .join(',');
    const status = "rejected";
    setShowEsignAlert(true);
    setEsignParams({ selectedIds, status,productionScheduleNames });
};

  //on password confirmation modal trigger 
  const handleESignConfirm = async (remarks: string) => {
    if (!esignParams) return;
    const { selectedIds, status, productionScheduleNames } = esignParams;
    await changeLabReportStatus(selectedIds, status,productionScheduleNames,remarks);
};
  
  //on trigger approve or reject button function call 
  const changeLabReportStatus = async (selectedIds: any, status : any,productionScheduleNames:string, approverRemarks: string) => {

    const dataToSend = {
        //flora_ids : selectedIds,
        user_id : userId,
        approval_status : status,
        production_schedule_name : productionScheduleNames,
        approver_remarks : approverRemarks,
        interface_name : "QA Review & Approval"
    }

    try {
      const response = await userService.changeQAReportStatus(dataToSend);
      if(response.status && response.statusCode === 200){
        setToastMessage(response.message);
        setToastType("success");
      } else {
        setToastMessage(response.message);
        setToastType("error");
      }
      setShowToast(true);
    } catch (error) {
      console.error('Plate response', error);
    }
    setkeyWord("")
    setShowEsignAlert(false)
    setEsignParams(null);
    setUseEffectRequired(true)
  }

  // function to sort table
  const handleSort = (key: string, value: boolean) => {
    setSort(key);
    if (value) {
      setOrder("asc");
    } else {
      setOrder("desc");
    }
    setUseEffectRequired(true);
  };

  const handleSortHistory = (key: string, value: boolean) => {
    setSortHistory(key);
    if (value) {
      setOrderHistory("asc");
    } else {
      setOrderHistory("desc");
    }
    setUseEffectRequired(true);
  };

  //on box click 
  const handleBoxClick = (value : number) => {
    setSelectedTab(value)
  };

  return (
    <div>
      <HeaderSection />
      <PageHeader pageHeader= "QA Review & Approval" />
      <CustomToast
        show={showToast}
        onClose={() => setShowToast(false)}
        delay={5000}
        message={toastMessage}
        toastType={toastType}
      />
      {/* <div className="container-lab">      
              <div className="box-display" style={{ backgroundColor: selectedTab === 1 ? '#e0e0e0' : '' }} onClick={() => handleBoxClick(1)}>
                    <h3 className='lab-dash-head'>{t("labreport.pendingPlates")}</h3>
                    <p className='lab-dash-value' style={{color : "#CBB613"}} >{labtestStat?.pending_plates_for_lab_approval}</p>
              </div>
              <div className="box-display" style={{ backgroundColor: selectedTab === 2 ? '#e0e0e0' : '' }} onClick={() => handleBoxClick(2)}>
                    <h3 className='lab-dash-head'>{t("labreport.approvedPlates")}</h3>
                    <p className='lab-dash-value'style={{color : "#148E04"}} >{labtestStat?.lab_approved_plates}</p>
              </div>
      </div> */}
       
      <div className='exceptionHandlingTab'>
        <button
          onClick={() => setTab("1")}
          className={tab === "1" ? "selectedNavBtn" : "navBtn"}
        >
          {t("labreport.requests")}
        </button>
        <button
          onClick={() => setTab("2")}
          className={tab === "2" ? "selectedNavBtn" : "navBtn"}
        >
          {t("labreport.history")}
        </button>
      </div>
      

      {/* QA request */}
      {tab === "1" && (
  <div className="me-3" style={{ marginTop: "10px" }}>
    <div className="mx-3 pe-2" style={{ height: "45vh"}}>
      <CustomTable
        data={plateDetails}
        columns={columnsNew}
        isEditable={false}
        totalElements={totalElements}
        isActionVisible={true}
        isViewVisible={true}
        onViewClick={handleViewClick}
        onFilterClick={handleFilter}
        approveButton={true}
        approveButtonText={t("buttons.approve")}
        rejectButton={true}
        rejectButtonText={t("buttons.reject")}
        tableHead={t("labreport.approvals")}
        onSortClick={handleSort}
        plateBatch={plateBatches}
        plateSerialNumber={plateSerielNum}
        onStartClick={handleApproveBtn}
        onEndClick={handleRejectBtn}
        ActivityType={activityType}
        areaDropList={areaList}
        showToDateFilter={true}
        showFromDateFilter={true}
        dateType='date'
        showFullFilters={true}
        showLotCodeFilter={false}
        showSerielNoFilter={false}
        prodScheduleList={prodScheduleList}
        productList={productList}
        removeSortList={sortRemoveList}
      />
    </div>
    <div>
      <Pagination
        page={page}
        totalPages={totalPages}
        handlePageChange={handlePageChange}
      />
          </div>

          <EsignModal 
            show={showEsignAlert}
            onHide={() => setShowEsignAlert(false)}
            onConfirm={handleESignConfirm}
            needRemraks={true}
            screenName={"QA Review And Approval"}
           />

        </div>
      )}

      {/* QA history */}
      {tab === "2" && (
      <div className="me-3" style={{ marginTop: "10px" }}>
        <div className="mx-3 pe-2" style={{ height: "45vh"}}>
          <CustomTable
            data={plateDetailsHistory}
            columns={columnsHistory}
            isEditable={false}
            totalElements={historyTotalElements}
            isActionVisible={false}
            isViewVisible={true}
            onViewClick={handleHistoryView}
            tableHead={t("labreport.pageTitle")}
            onFilterClick={handleHistoryFilter}
            onSortClick={handleSortHistory}
            plateBatch={plateBatches}
            plateSerialNumber={plateSerielNum}
            ActivityType={activityType}
            areaDropList={areaList}
            showToDateFilter={true}
            showFromDateFilter={true}
            dateType='date'
            showFullFilters={true}
            showLotCodeFilter={false}
            showSerielNoFilter={false}
            prodScheduleList={prodScheduleList}
            productList={productList}
            removeSortList={sortRemoveListHistory}
          />
        </div>
      <div>
        <Pagination
          page={historyPage}
          totalPages={historyTotalPages}
          handlePageChange={handleHistoryPageChange}
        />
      </div>
      </div>
      )}


        {/*modal for download QR*/}
      <Modal
        className="top-right-modal-lg"
        centered={false}
        size="lg"
        show={showView}
      >
        <div className="modalHead">
          <p className="modalHeadText ms-3 pt-3 p-2">Production Batch Report</p>
          <div
            style={{ cursor: "pointer" }}
            onClick={() => setShowView(false)}
            className="p-2 mx-3 my-2 "
          >
            <TfiClose fill="#FFFFFF" />
          </div>
        </div>
        <div className="mt-2" style={{"overflow":"scroll", "height": "80vh"}}>
          <ProductionBatchSummaryReport ishide={true} productionScheduleId={plateId} />
        </div>
        <div className="bottomArea">
        <button
          onClick={() => setShowView(false)}
          className="modalCancelBtn"
        >
          {t("buttons.cancel")}
        </button>
        </div>
      </Modal>

    </div>
  );
};


export default QAReviewAndApproval;



